import axiosInstance from "../config/AuthInterceptors";
import { IRole, IRoleGenericResponse, IRoleGetListResponse } from "../interfaces/roles";

const rolesService = {
    getAll: (skip: number = 0, limit: number = 25) => axiosInstance.get<IRoleGetListResponse>("/roles?skip=" + skip + "&limit=" + limit).then(res => res.data),
    get: (id: string) => axiosInstance.get<IRoleGenericResponse>("/roles/" + id).then(res => res.data),
    post: (body: Partial<IRole>) => axiosInstance.post<IRoleGenericResponse>("/roles", body).then(res => res.data),
    put: (id: string, body: Partial<IRole>) => axiosInstance.put<IRoleGenericResponse>("/roles/" + id, body).then(res => res.data),
    delete: (id: string) => axiosInstance.delete<IRoleGenericResponse>("/roles/" + id).then(res => res.data),
}

export default rolesService;